import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useUsers, User } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';

const List: React.FC = () => {
  const { colors } = useTheme();
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return (
    <div className={cn('flex flex-col h-full min-h-0', colors.background)}>
      <div className="flex-1 min-h-0 overflow-hidden">
        <GenericListPage<User> useData={useUsers} config={config} />
      </div>
    </div>
  );
};

export default List;
